import { signTypes } from '../types';

const initialState = {
    loading: false,
    tab: 'login',
    loginMode: 'login',
    logout: false,
    register: null,
    user: null,
    isLogged: false,
    _token: null,
    resetPassword: {
        loading: false,
        email: null,
        sentEmail: false,
        token: null,
        newPassword: null,
        retypeNewPassword: null,
        isVerified: null,
    },
    error: null
};

export const sign = (state = initialState, action) => {
    switch (action.type) {
        case signTypes.TABS_CHANGE:
            return {
                ...state,
                tab: action.tab,
                loginMode: 'login',
                error: null
            };
        case signTypes.LOGIN_VIEW_CHANGE:
            return {
                ...state,
                loginMode: action.loginMode,
                tab: action.tab
            };
        case signTypes.LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
                user: action.user,
            };
        case signTypes.LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.user,
                isLogged: action.isLogged,
            };
        case signTypes.LOGIN_ERROR:
            return {
                ...state,
                loading: false,
                user: null,
                isLogged: false,
                _token: null,
                error: action.error,
            };
        case signTypes.LOGGED_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.user,
                isLogged: action.isLogged,
                _token: action._token,
            };
        case signTypes.LOGGED_ERROR:
            return {
                ...state,
                loading: false,
                user: null,
                isLogged: false,
                _token: null,
                error: action.error,
            };

        case signTypes.RESET_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                resetPassword: {
                    ...state.resetPassword,
                    loading: true,
                    email: action.email,
                    sentEmail: false,
                },
            };
        case signTypes.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                loginMode: 'sentForgotPassword',
                resetPassword: {
                    ...state.resetPassword,
                    loading: false,
                    email: action.email,
                    sentEmail: true,
                },
            };
        case signTypes.RESET_PASSWORD_ERROR:
            return {
                ...state,
                loading: false,
                resetPassword: {
                    ...state.resetPassword,
                    loading: false,
                    email: null,
                    sentEmail: false,
                },
                error: action.error,
            };

        case signTypes.REGISTER_REQUEST:
            return {
                ...state,
                loading: true,
                register: action.register,
                user: null,
            };
        case signTypes.REGISTER_SUCCESS:
            return {
                ...state,
                loading: false,
                register: null,
                user: {
                    ...state.user,
                    email: state.register.email,
                },
                loginMode: 'registerSummary',
                tab: 'register',
            };
        case signTypes.REGISTER_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        }
        case signTypes.REGISTER_RECOGNIZED_REQUEST:
            return {
                ...state,
                loading: true,
                register: {
                    ...state.register,
                    email: action.email,
                },
            };

        case signTypes.REGISTER_RECOGNIZED_EMAIL:
            return {
                ...state,
                loading: false,
                tab: 'login',
                loginMode: 'recognizedEmail',
                user: {
                    ...state.user,
                    email: action.email,
                },
                register: null,
            };
        case signTypes.REGISTER_RECOGNIZED_ERROR:
            return {
                ...state,
                loading: true,
                register: {
                    ...state.register,
                    email: action.email,
                },
            };

        case signTypes.SET_PASSWORD_LOADING:
            return {
                ...state,
                loading: false,
                resetPassword: {
                    ...state.resetPassword,
                    token: action.token,
                },
                tab: 'newPassword',
            };
        case signTypes.SET_PASSWORD_READY:
            return {
                ...state,
                loading: false,
                resetPassword: {
                    ...state.resetPassword,
                    token: action.token,
                    isVerified: true,
                },
                tab: 'newPassword',
            };
        case signTypes.SET_PASSWORD_NOT_VERIFY:
            return {
                ...state,
                loading: false,
                resetPassword: {
                    ...state.resetPassword,
                    token: null,
                    isVerified: false,
                },
                tab: 'newPassword',
            };

        case signTypes.SET_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                resetPassword: {
                    ...state.resetPassword,
                    token: action.token,
                    newPassword: action.newPassword,
                    retypeNewPassword: action.retypeNewPassword,
                },
                tab: 'newPassword',
            };
        case signTypes.SET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                resetPassword: {
                    ...initialState.resetPassword,
                },
                tab: 'login',
                loginMode: 'setNewPassword',
            };
        case signTypes.SET_PASSWORD_ERROR:
            return {
                ...state,
                loading: false,
                resetPassword: {
                    ...state.resetPassword,
                    status: 'error',
                },
            };

        case signTypes.LOGOUT_REQUEST:
            return {
                ...state,
                logout: true,
            };

        case signTypes.LOGOUT:
            return initialState;

        default:
            return state;
    }
};
